/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// MUI Icons
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { Stack } from '@mui/material';

export const enum LoginErrorType {
  Registered = 5,
  Inactive = 6,
  General = 7,
  HPSLicence = 8,
  HPSDisabled = 9
}

const enum LoginErrorCategory {
  Warning = "warning",
  Error = "error"
}

type LoginErrorBoxProps = {
  errorType: LoginErrorType;
  onResendToken: () => void;
};

function LoginErrorBox(props: LoginErrorBoxProps) {
  const { t } = useTranslation();

  const { errorType, onResendToken } = props;

  const errorCategory: LoginErrorCategory = (errorType === LoginErrorType.Registered || errorType === LoginErrorType.HPSLicence) ?  LoginErrorCategory.Warning : LoginErrorCategory.Error;

  const IconComponent = errorCategory === LoginErrorCategory.Warning ? WarningIcon : ErrorIcon;
  const iconColor = errorCategory === LoginErrorCategory.Warning ? "warning" : "error";

  const messageToken1 =
    errorType === LoginErrorType.Registered
      ? 'login_errors.registered_1'
      : errorType === LoginErrorType.Inactive
      ? 'login_errors.inactive_1'
      : errorType === LoginErrorType.HPSLicence
      ? 'login_errors.hps_licence_1'
      : errorType === LoginErrorType.HPSDisabled
      ? 'login_errors.hps_disabled_1'
      : errorType === LoginErrorType.General
      ? 'login_errors.general_1'
      : 'login_errors.general_1';

  const messageToken2 =
    errorType === LoginErrorType.Registered
      ? 'login_errors.registered_2'
      : errorType === LoginErrorType.Inactive
      ? 'login_errors.inactive_2'
      : errorType === LoginErrorType.HPSLicence
      ? 'login_errors.hps_licence_2'
      : errorType === LoginErrorType.HPSDisabled
      ? 'login_errors.hps_disabled_2'
      : errorType === LoginErrorType.General
      ? 'login_errors.general_2'
      : 'login_errors.general_2';

  const showResendButton = errorType === LoginErrorType.Registered;

  return (
    <Stack>
      <Box display="flex" alignItems="center" gap={2} sx={{ my: 1 }}>
        <Stack>
          <Typography variant="body1" fontWeight={500} color="error" sx={{ mb: 1 }}>
            {t(messageToken1)}
          </Typography>
          <Typography variant="body1" color="error">
            {t(messageToken2)}
          </Typography> 
        </Stack>
        <IconComponent sx={{ fontSize: 32 }} color={iconColor} />
      </Box>
      {showResendButton ? (
        <Button onClick={onResendToken} variant="contained" sx={{ mt: 1, width: "max-content" }}>
          {t('messages.register.confirm.token_resend')}
        </Button>
      ) : null}
    </Stack>
  );
}

export default LoginErrorBox;
